import { Axios } from "../Hooks/useAxiosInstance";
import { useAppContext } from "../Context/AppContext";
import { API_ROUTE } from "../Config";

export const QuestionAPI = () => {
  const { user } = useAppContext();

  const apis = ({ api_token }) => ({
    create: async (data) => await createQuestion(data, api_token),
    update: async ({ id, data }) => await updateQuestion(id, data, api_token),
    getQuestions: async (params) => await getQuestions(params, api_token),
    deleteQuestion: async (id) => await deleteQuestion(id, api_token),
    updateStatus: async (id, data) => await updateStatus(id, data, api_token),
  });



  async function createQuestion(data, api_token) {
    const url = API_ROUTE.ADD_QUESTION;
    const option = {
      headers: {
        Authorization: api_token,
        "Content-Type": "application/json",
      },
    };
    return await Axios.post(url, data, option);
  }

  async function updateQuestion(id, data, api_token) {
    const url = API_ROUTE.UPDATE_QUESTION(id);
    const option = {
      headers: {
        Authorization: api_token,
        "Content-Type": "application/json",
      },
    };
    return await Axios.patch(url, data, option);
  }


  async function getQuestions(params, api_token) {
    const url = API_ROUTE.GET_QUESTION_LIST;
    const option = {
      headers: {
        Authorization: api_token,
      },
      params: params,
    };
    return await Axios.get(url, option);
  }


  async function deleteQuestion(id, api_token) {
    const url = `${API_ROUTE.DELETE_QUESTION}/${id}`;
    const option = {
      headers: {
        Authorization: api_token,
      },
    };
    return await Axios.delete(url, option);
  }

  async function updateStatus(id, data, api_token) {
    const url = `${API_ROUTE.UPDATE_STATUS}/${id}`;
    const option = {
      headers: {
        Authorization: api_token,
        "Content-Type": "application/json",
      },
    };
    return await Axios.patch(url, data, option);
  }


  return apis({ api_token: user.api_token });
};